import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';   /* ← Global design tokens — loaded first */
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './fontawesome';
import { MsalProvider } from "@azure/msal-react";
import { msalInstance, initializeMsal } from "./auth/msalInstance";
import { PublicClientApplication } from "@azure/msal-browser";

// Create a fallback MSAL instance for when Entra is not configured
const msalProviderInstance = msalInstance || new PublicClientApplication({
  auth: {
    clientId: "00000000-0000-0000-0000-000000000000",
    authority: "https://login.microsoftonline.com/common",
  }
});

// Initialize MSAL before rendering
initializeMsal().then(() => {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalProviderInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
